let interval;
const delay = 6000;
let lastTime;
let timeLapse;

function play() {
  const time = Date.now();
  if (lastTime) {
    const delta = time - lastTime;
    timeLapse = (timeLapse || 0) + delta;
    if (timeLapse >= delay) {
      timeLapse = 0;
      slide();
    }
  }

  lastTime = time;
  interval = window.requestAnimationFrame(play);
}

function slide() {
  const container = document.querySelector('.testimonies ul');
  const slides = container.querySelectorAll('li');
  const slide = slides[0];
  const width = slide.offsetWidth;
  slide.style.marginLeft = `-${width}px`;
  setTimeout(() => {
    container.append(slide);
    slide.style.marginLeft = `0`;
  }, 500);
}

play();